import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchWishlist } from "../../features/wishlist/wishlistSlice";
import Navbar from "../Navbar";
import Footer from "../layouts/Footer";
import "./Wishlist.css";

const WishlistComponent = () => {


   const dispatch = useDispatch();

   // Get wishlist data from Redux store
   const { wishlist, loading, error } = useSelector((state) => state.wishlist);
   console.log("wishlist", wishlist)

   useEffect(() => {
     // Fetch wishlist items when component mounts
     dispatch(fetchWishlist());
   }, [dispatch]);

   const handleAddToCart = (item) => {
     console.log(`Added ${item.name} to cart`);
     // Add logic here to move the item to the cart
   };

  // const handleAddToCart = (item) => {
  //   console.log(`Added ${item.name} to cart`);
  //   // Add logic here to move the item to the cart
  // };

  const handleRemoveFromWishlist = (id) => {
    console.log(`Removed item with id ${id} from wishlist`);
    // Add logic here to remove the item from the wishlist
  };

  return (
    <>
      <Navbar />
      <div className="wishlist-page container">
        <h2 className="my-4">Your Wishlist</h2>
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p>Error: {error}</p>
        ) : wishlist.length === 0 ? (
          <div className="wishlist-empty">
            <p>Your wishlist is currently empty.</p>
          </div>
        ) : (
          <div className="row">
            {[
              {
                name: "Registers",
                imageUrl: "/assets/images/items/21.jpg",
                price: 18,
              },
              {
                name: "Duplicate Books",
                imageUrl: "/assets/images/items/4.jpg",
                price: 14,
              },
              {
                name: "Cash Memo Books",
                imageUrl: "/assets/images/items/28.jpg",
                price: 16,
              },
              {
                name: "Red Cloth Copy",
                imageUrl: "/assets/images/items/10.jpg",
                price: 22,
              },
            ].map((item, index) => (
              <div className="col-md-4 mb-4" key={index}>
                <div className="card">
                  <img
                    src={item.imageUrl || "assets/images/auth/img-auth-1.jpg"}
                    alt={item.name}
                    className="card-img-top"
                    style={{ height: "150px", objectFit: "cover" }}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{item.name}</h5>
                    <p className="card-text">Rs. {item.price}</p>
                    <div className="d-flex justify-content-between">
                      <Link
                        to={`/productdetail/${index}`}
                        className="btn btn-link"
                      >
                        View Details
                      </Link>
                      <div>
                        <button
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => handleAddToCart(item)}
                        >
                          Add to Cart
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleRemoveFromWishlist(index)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default WishlistComponent;
